import { useMutation, useQueryClient } from "@tanstack/react-query";

import { isLoggedIn } from "@/utils/auth";

import { $api, fetchClient, invalidate } from "./client";
import type { components } from "./schema";

export type UserPreferences = components["schemas"]["UserPreferences"];
export type PatchedUserPreferences =
  components["schemas"]["PatchedUserPreferencesRequest"];
export type User = components["schemas"]["User"];
export type PatchedUser = components["schemas"]["PatchedUserRequest"];

/** The currently authenticated user. */
export const useMe = () =>
  $api.useQuery("get", "/api/v1/me/", undefined, { staleTime: 5 * 60 * 1000 });

export function useUpdateMe() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (patch: PatchedUser) =>
      (await fetchClient.PATCH("/api/v1/me/", { body: patch })).data!,
    onSuccess: () => invalidate(queryClient, "/api/v1/me/"),
  });
}

/** Auto-created on first read. */
export const usePreferences = () =>
  $api.useQuery("get", "/api/v1/me/preferences/", undefined, {
    enabled: isLoggedIn(),
    staleTime: 5 * 60 * 1000,
  });

export function useUpdatePreferences() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (patch: PatchedUserPreferences) =>
      (await fetchClient.PATCH("/api/v1/me/preferences/", { body: patch }))
        .data!,
    onSuccess: () => invalidate(queryClient, "/api/v1/me/preferences/"),
  });
}
